const SELECTORS = {
  gallery: '.gallery__media',
  galleryThumbnails: '.gallery-thumbnails',
  galleryMobileSwiper: '.gallery__container.below-mobile',
  thumbLinksWrap: '.gallery-thumbnails__items',
  thumbLink: '.gallery-thumbnails__item-link',
  thumbID: 'data-thumbnail-id',
  mainImgID: 'data-media-item-id',
  activeClass: 'active',
};
/**
 *
 */
const changeImage = () => {
  const thumbLinksWrap = document.querySelector(SELECTORS.thumbLinksWrap);
  const thumbLink = thumbLinksWrap.querySelectorAll(SELECTORS.thumbLink);
  const mediaGallery = document.querySelector(SELECTORS.gallery);
  if (thumbLink && thumbLink.length > 0) {
    thumbLink.forEach((link) => {
      link.addEventListener('click', () => {
        if (!link.classList.contains(SELECTORS.activeClass)) {
          thumbLinksWrap.querySelector(`${SELECTORS.thumbLink}.${SELECTORS.activeClass}`)?.classList.remove(SELECTORS.activeClass);
          const thumbID = link.getAttribute(SELECTORS.thumbID);
          const mainImgToActive = mediaGallery.querySelector(`[${SELECTORS.mainImgID}="${thumbID}"]`);
          if (!mainImgToActive.classList.contains(SELECTORS.activeClass)) {
            mediaGallery.querySelector(`[${SELECTORS.mainImgID}].${SELECTORS.activeClass}`)?.classList.remove(SELECTORS.activeClass);
            mainImgToActive.classList.add(SELECTORS.activeClass);
          }
          link.classList.add(SELECTORS.activeClass);
        }
      });
    });
  }
};
/**
 * Init lightbox
 *
 * @param {object} module module obj
 */
const initGalleryLightBox = (module) => {
  const { icons } = window.theme;
  const { PhotoSwipeLightbox } = module;
  const { PhotoSwipe } = module;
  const productLightbox = new PhotoSwipeLightbox({
    gallery: '[data-gallery-lightbox]',
    children: '.lightbox-image',
    pswpModule: PhotoSwipe,
    mainClass: 'pswp--product-lightbox',
    bgOpacity: 1,
    arrowPrevSVG: icons.chevron,
    arrowNextSVG: icons.chevron,
    closeSVG: icons.close,
    zoomSVG: icons.zoom,
  });
  productLightbox.init();
};
/**
 * @param Swiper
 * @param Pagination
 */
const initMobileGallerySlider = (Swiper, Pagination) => {
  const swiperContainer = document.querySelector(SELECTORS.galleryMobileSwiper);
  const swiperOptions = {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 0,
    watchOverflow: true,
    loop: false,
    centeredSlides: false,
    pagination: {
      el: '.gallery__container.below-mobile .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  };
  if (swiperContainer && Swiper) {
    // eslint-disable-next-line no-unused-vars
    const gallerySwiper = new Swiper(swiperContainer, swiperOptions);
  }
};
document.addEventListener('DOMContentLoaded', () => {
  window.scrollContainer(document.querySelector(SELECTORS.galleryThumbnails));
  window.LoadLightbox.then((module) => {
    initGalleryLightBox(module);
    changeImage();
  });
  if (window.screen.width <= 960) {
    window.LoadSwiper.then((module) => {
      initMobileGallerySlider(module.Swiper, module.Pagination);
    });
  }
  window.addEventListener('resize', () => {
    if (window.screen.width <= 960) {
      const swiperContainer = document.querySelector(SELECTORS.galleryMobileSwiper);
      if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
        window.LoadSwiper.then((module) => {
          initMobileGallerySlider(module.Swiper, module.Pagination);
        });
      }
    }
  });
});
